import RequiredIndicator from './RequiredIndicator';

export default RequiredIndicator;
